// escape a string so it's safe to interpolate into an HTML string, whether
// it ends up in element text content or inside a quoted attribute value
export function escapeHtml(value: string): string {
  return value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}
